import ScrollToBottom from 'react-scroll-to-bottom';
import styled from 'styled-components';

export const MessagesContainer = styled(ScrollToBottom)`
  padding: 5% 0;
  overflow: auto;
  flex: auto;
`;
